import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import IndustriesGrid from "@/components/site/IndustriesGrid";
import InsightsPreview from "@/components/site/InsightsPreview";
import ContactCTA from "@/components/site/ContactCTA";

export default function Home() {
  return (
    <main data-testid="page-home">
      <Hero />
      <Services />
      <IndustriesGrid />
      <InsightsPreview />
      <ContactCTA />
    </main>
  );
}
